import { REQUEST_STATUSES } from "@/constants/index.js";
import { getNewList } from "@/utils/helper.js";

import * as types from "./types.js";

const initialContactState = {
  contacts: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

const initialState = {
  organizations: {},
  properties: {},
};

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CONTACTS: {
      const { propertyId, organizationId, contacts, status, err, query } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      const newContacts = getNewList(query, state[key]?.[id]?.contacts || [], contacts);

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: {
            contacts: newContacts,
            status,
            err,
            noResults: !newContacts.length,
          },
        },
      };
    }
    case types.ADD_CONTACT: {
      const { propertyId, organizationId, contact, status } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: { ...(state[key]?.[id] || {}), contacts: [...(state[key]?.[id]?.contacts || []), contact], status },
        },
      };
    }

    case types.UPDATE_CONTACT: {
      const { propertyId, organizationId, updatedContact, status } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;
      const updatedContacts = (state[key]?.[id]?.contacts || []).map((contact) => {
        return contact.id === updatedContact.id ? { ...contact, ...updatedContact } : contact;
      });

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: { ...(state[key]?.[id] || {}), contacts: updatedContacts, status },
        },
      };
    }

    case types.SET_CONTACTS_REQUEST_STATUS: {
      const { propertyId, organizationId, status } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: { ...(state[key]?.[id] || {}), status },
        },
      };
    }
    case types.RESET_CONTACTS: {
      const { propertyId, organizationId } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: initialContactState,
        },
      };
    }
    default:
      return state;
  }
};
